var file_upload_viewer_default = {
  "fontElementMap": "hioWM",
  "file_upload_container": "ZSDCE",
  "file_upload_link": "jbW7p",
  "file_upload_error_container": "SJndm",
  "file_upload_file_info": "Pt1vr",
  "file_upload_type_icon": "hTYdf",
  "file_upload_status_icon_container": "XE-lX",
  "file_upload_status_icon": "k9E0D",
  "file_upload_description": "BXTQV",
  "file_upload_name_container": "NkSnV",
  "file_upload_name": "QXKse",
  "file_upload_extension": "S33ma",
  "file_loader_icon": "MBgcy",
  "file_upload_icon_frame": "G6SxM",
  "file_upload_icon_background": "ZoX3G"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
